'use client'

import dayjs from 'dayjs'
import Modal from '@/components/Modal'

import { useLocale } from 'core/components/Locale'
import { getSupportArticleDetail } from 'core/service/yapi/hk-web/CmsSupport/api'
import { copyContent } from 'core/utils/clipboard'
import HeaderSearch from '@/app/[lang]/support/_components/HeaderSearch'
import notification from '@/components/notification'
import recordPCEvent from 'core/utils/RecordEvent/recordPCEvent'

import logo from '../../_assets/img/s-logo.png'
import styles from './index.module.scss'
import { PhoneTop } from '../PhoneTop'
import BreadCrumb from '../BreadCrumb'

import shareImg from '../../_assets/img/support-icon9-w.png'
import { useMemo, useState, useEffect, useCallback } from 'react'

import { useCurrentUrl, useQueryString } from '@/hooks/useHooks'
import FooterLink from './FooterLink'
import TRecordPCEvent from 'core/utils/RecordEvent/TRecordPCEvent'
import { usePostRewardActivityApplyMutation } from 'core/query/yapi/hk-web/Reward/query'
type ClientArticleProps = {
  articleDetail: Awaited<ReturnType<typeof getSupportArticleDetail>>['data']['data']
}

function ClientArticlePage({ articleDetail }: ClientArticleProps) {
  const t = useLocale()
  const ctype = articleDetail?.ctype
  const articleTitle = articleDetail?.title

  const {
    queryString: { utm_campaign, utm_id, utm_source },
  } = useQueryString<{
    utm_campaign: string
    utm_id: string
    utm_source: string
  }>()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsClient(true)
    }
  }, [])

  const currentUrl = useCurrentUrl()

  const text = useMemo(() => {
    return t('support_019')
      .replace('$[title]', articleDetail?.title ? articleDetail?.title : '')
      .replace('$[link]', currentUrl)
  }, [articleDetail?.title, t, currentUrl])

  const onCopy = useCallback(() => {
    copyContent(text)
    notification.success({
      message: t('support_033'),
    })
  }, [text, t])

  const handleShare = useCallback(() => {
    if (typeof window === 'undefined') return
    const isPhone = window.innerWidth < 768
    if (isPhone) {
      setIsModalOpen(true)
      return
    }
    onCopy()
  }, [onCopy])

  const { mutate } = usePostRewardActivityApplyMutation({
    onSuccess: () => {
      notification.success({
        message: t('hotcoinWeb_v_1_3_99_SuccessfulRegistration'),
      })
    },
  })

  const handleActivityClick = useCallback(
    async (event: MouseEvent) => {
      try {
        const target = event.target as HTMLElement
        const activityElement = target.closest('#activity')

        if (!activityElement) return

        event.preventDefault()

        const activityId = activityElement.getAttribute('data-id')

        if (activityId) {
          const trackingEvent =
            utm_campaign && utm_id && utm_source
              ? `${utm_campaign}_${utm_id}_${utm_source}_Register`
              : `Activity_${activityId}_Register`

          recordPCEvent.record(trackingEvent as keyof TRecordPCEvent)

          mutate({
            activityId: Number(activityId),
          })
        }

        const activityUrl = activityElement.getAttribute('data-url')
        if (activityUrl) {
          window.open(activityUrl, '_blank')
        }
      } catch (error) {
        console.error(error)
      }
    },
    [utm_campaign, utm_id, utm_source, mutate]
  )

  useEffect(() => {
    document.addEventListener('click', handleActivityClick)
    return () => {
      document.removeEventListener('click', handleActivityClick)
    }
  }, [handleActivityClick])

  return (
    <>
      <Modal showCloseBtn={false} open={isModalOpen} onClose={() => setIsModalOpen(false)} width={300}>
        <div className={styles.share}>
          <img src={shareImg.src} alt="" />
          <div className={styles.text}>{text}</div>
          <div className={styles.btns}>
            <button
              onClick={() => {
                setIsModalOpen(false)
              }}
            >
              {t('person_setting_098')}
            </button>
            <button
              onClick={() => {
                onCopy()
              }}
            >
              {t('person_setting_181')}
            </button>
          </div>
        </div>
      </Modal>
      <PhoneTop title={articleTitle || ''} />
      <article className={styles.article}>
        <HeaderSearch background="gray" title={ctype == 1 ? t('support_010') : t('support_011')} />

        <BreadCrumb
          className=" border-b-[0.1px] border-b-[rgb(238, 238, 238)] md:border-b-0"
          ctype={ctype?.toString() || '1'}
          catalog={articleDetail || {}}
        />
        <div className={styles.content}>
          <header className={styles.contentHeader}>
            <h1 className={styles.title}>{articleTitle}</h1>
            <div className={styles.time}>
              <div className={styles.timeLeft}>
                <img src={logo.src} alt="Hotcoin logo for the article" />
                <span className={styles.subTitle}>Hotcoin</span>
                {isClient && (
                  <time
                    className={styles.createTime}
                    dateTime={dayjs(articleDetail?.createdTime).format('YYYY-MM-DDTHH:mm')}
                  >
                    {dayjs(articleDetail?.createdTime).format('YYYY-MM-DD HH:mm')}
                  </time>
                )}
              </div>
              <div className={styles.timeRight} onClick={handleShare}>
                <i className="iconfont iconfenxiang "></i>
                <div className="hide-phone">{t('support_018')}</div>
              </div>
            </div>
          </header>
          <section
            dangerouslySetInnerHTML={{ __html: articleDetail?.content || '' }}
            className={`${styles.contentInnerHtml} `}
          ></section>
          <FooterLink isShow={ctype === 2} />
        </div>
      </article>
    </>
  )
}

export default ClientArticlePage
